import { Log } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/forum';
import { IForumData, ISetHomePageConversation, ISetForumConversation, ISetForumMessage, ISetForumThreadById, ISetAnswers, ISetMessageData, ISetMessageUpdateData } from '../../models/action/forum';

const _logger = Log.create('Forum Reducer');

const setForumData = (newState: any, action: any) => {
    const forumPageAction = (action as unknown as IForumData);

    newState.forumData = {
        activityId: forumPageAction.activityId,
        abbreviation: forumPageAction.abbreviation,
        name: forumPageAction.name,
        description: forumPageAction.description,
        firstForumMessage: forumPageAction.firstForumMessage,
        isCommon: forumPageAction.isCommon ? 1 : 0,
        dateCriteria: forumPageAction.dateCriteria,
        datePrerequisiteActivityHours: forumPageAction.datePrerequisiteActivityHours ?? '',
        datePrerequisiteActivityId: forumPageAction.datePrerequisiteActivityId ? [forumPageAction.datePrerequisiteActivityId] : '',
        prerequisiteActivityId: forumPageAction.prerequisiteActivityId ?? '',
        completionType: forumPageAction.completionType,
        completionCriteria: forumPageAction.completionCriteria,
        alwaysOnTop: forumPageAction.alwaysOnTop,
        dateRange: '',
        fileInputKey: '',
        photoUploadKey: '',
        activityConditionalBeginDate: forumPageAction?.beginDate,
        activityConditionalEndDate: forumPageAction?.endDate,
        termWeekIds: forumPageAction?.termWeekIds,
        selectedActivityOwnersTagIds: forumPageAction.selectedActivityOwnersTagIds,
        selectedActivityUnitsTagIds: forumPageAction.selectedActivityUnitsTagIds,
        selectedClass: forumPageAction?.selectedClass,
        allUnits: forumPageAction.allUnits,
        courseId: forumPageAction.courseId,
        beginDate: forumPageAction.beginDate,
        endDate: forumPageAction.endDate,
        file: forumPageAction?.file && forumPageAction?.file.length > 0 ? forumPageAction?.file : null,
        deletedFilesId: [],
        hasModerator: forumPageAction.hasModerator,
        cardImgName: forumPageAction.cardImgName,
        taskDeadLine: forumPageAction.taskDeadLine,
        learningOutcomeId: forumPageAction.learningOutcomeId,
    };
}

const setForumAnswers = (newState: any, action: any, state: any) => {
    const forumPageAction = (action as ISetAnswers);
    const forumMessages = state.forumMessages;

    if (forumPageAction.skip === 0) {
        forumMessages.forEach((message: any) => {
            if (message.forumMessageId === forumPageAction.messageId) {
                message.answers = forumPageAction.answers;
            }
        });
    }

    newState.forumMessages = forumMessages;
}

const setForumMessages = (newState: any, action: any, state: any) => {
    const forumPageAction = (action as ISetForumMessage);
    if (forumPageAction.skip === 0) {
        newState.forumMessages = [];
        newState.forumMessages = newState.forumMessages.concat(forumPageAction.forumMessages);

    } else {
        newState.forumMessages = state.forumMessages;
        newState.forumMessages = newState.forumMessages.concat(forumPageAction.forumMessages);
    }
    newState.forumMessageTake = forumPageAction.take;
    newState.forumMessageSkip = forumPageAction.skip;
    newState.forumMessageThreadId = forumPageAction.forumThreadId;
    newState.forumMessageSubject = forumPageAction.forumSubject;
}

const setUpdateForumMessages = (newState: any, forumPageAction: any, state: any) => {
    const forumMessages = state.forumMessages;

    const updatedMessages = forumMessages.map((message: any) => {
        if (message.forumMessageId === forumPageAction.messageData.forumMessageId) {
            return {
                ...message,
                messageStatus: forumPageAction.isApproved ? 0 : 3,
            };
        }
        return message;
    });

    newState.forumMessages = updatedMessages;
}

const forumReducer = (state = GlobalState().forum, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {};
    if (action.type === Actions.actions.SET_MY_GROUP) {
        const forumPageAction = (action as ISetHomePageConversation);
        newState.homePageConversation = forumPageAction.homePageConversation;
    } else if (action.type === Actions.actions.FORUM_SET_CONVERSION) {
        const forumPageAction = (action as ISetForumConversation);
        if (forumPageAction.skip === 0) {
            newState.forumConversation = [];
        } else {
            newState.forumConversation = state.forumConversation;
        }
        newState.forumConversation = newState.forumConversation.concat(forumPageAction.forumConversation);
        newState.forumTake = forumPageAction.take;
        newState.forumSkip = forumPageAction.skip;
    } else if (action.type === Actions.actions.FORUM_SET_FORUMMESSAGE) {
        setForumMessages(newState, action, state);
    } else if (action.type === Actions.actions.FORUM_SET_THREADBYID) {
        const forumPageAction = (action as ISetForumThreadById);
        const createAndEditData = { subject: '', forumThreadId: '', isModerated: false };
        createAndEditData.subject = forumPageAction.forumData.subject!;
        createAndEditData.forumThreadId = forumPageAction.forumData.forumThreadId!;
        createAndEditData.isModerated = forumPageAction.forumData.isModerated!;
        newState.createAndEditData = { ...createAndEditData };
    } else if (action.type === Actions.actions.SET_FORUM_DATA_DEFAULT) {
        newState.forumData = {
            isUpdate: false,
            isCommon: 0,
            name: '',
            description: '',
            firstForumMessage: '',
            filterActivityView: 'criterionDate',
            dateRange: '',
            selectActivity: [],
            finishingCriterionActivity: '1',
            activityCompletionType: 1,
            note: 0,
            allUnits: false,
            selectUnits: [],
            selectCondition: [],
            selectOwner: [],
            completionType: 1,
            alwaysOnTop: false,
            dateCriteria: 0,
            fileInputKey: '',
            selectedClass: [],
            allowDownload: false,
            activitytype: '1',
            taskDeadline: '',
            selectWeek: [],
            termWeekIds: [],
            activityTime: 0,
            selectedActivityUnitsTagIds: [],
            selectedActivityOwnersTagIds: [],
            prerequisiteActivityId: '',
            datePrerequisiteActivityId: '',
            cardImgName: '',
            learningOutcomeId: null,
        };
    } else if (action.type === Actions.actions.SET_FORUM_DATA) {
        setForumData(newState, action);
    } else if (action.type === Actions.actions.FORUM_SET_ANSWERS) {
        setForumAnswers(newState, action, state);
    } else if (action.type === Actions.actions.SET_MESSAGE_DATA) {
        const forumPageAction = (action as unknown as ISetMessageData);
        newState.messageData = forumPageAction.messageData;
    } else if (action.type === Actions.actions.SET_MESSAGE_UPDATE_DATA) {
        const forumPageAction = (action as unknown as ISetMessageUpdateData);
        setUpdateForumMessages(newState, forumPageAction, state);
    } else if (action.type === Actions.actions.SET_DEFAULT_MESSAGE_DATA) {
        newState.forumMessages = [];
        newState.forumMessageTake = 0;
        newState.forumMessageSkip = 0;
        newState.forumMessageThreadId = '';
        newState.forumMessageSubject = '';
    }

    return Object.assign({}, state, newState);
};

export default forumReducer;